import {AccountFieldsPrefix, withPrefix} from '@/constants/prv-comp';
import {DocumentData} from '@/engine';
import {AccountInvestments} from '@/types/client-info';
import {COMP_TO_INVESTMENT_MAPPINGS} from './comp-to-investment-mappings';
import {findIndexedValuesInStore, reorderItemsByKey} from './reorder-items-by-key';

export const reorderInvestments = (
  oldStoreData: DocumentData['data'],
  freshInvestments: AccountInvestments,
  prefix: AccountFieldsPrefix,
): AccountInvestments =>
  COMP_TO_INVESTMENT_MAPPINGS.reduce(
    (result, {compKeyField, investmentType, getKey}) => ({
      ...result,
      [investmentType]: reorderItemsByKey(
        findIndexedValuesInStore(oldStoreData, withPrefix(compKeyField, prefix)),
        freshInvestments[investmentType],
        getKey,
      ),
    }),
    freshInvestments,
  );

export const reorderAccountInvestments = <T extends {investments: AccountInvestments | null}>(
  account: T,
  oldStoreData: DocumentData['data'],
  prefix: AccountFieldsPrefix,
): T =>
  account.investments
    ? {...account, investments: reorderInvestments(oldStoreData, account.investments, prefix)}
    : account;
